export default function TapHeroIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M10 52C8 24 56 24 54 52z" fill="#7bd65a" stroke="#3f8a2a" strokeWidth="3" />
      <circle cx="24" cy="38" r="6" fill="#fff" />
      <circle cx="40" cy="38" r="6" fill="#fff" />
      <circle cx="25" cy="39" r="3" fill="#1b1b2a" />
      <circle cx="41" cy="39" r="3" fill="#1b1b2a" />
      <path d="M26 47q6 4 12 0" stroke="#1b1b2a" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M44 6l4 8 9 1-7 6 2 9-8-5-8 5 2-9-7-6 9-1z" fill="#ffd84d" stroke="#e08a00" strokeWidth="2" strokeLinejoin="round" />
      <text x="13" y="20" fontSize="14" fontWeight="900" fill="#ff5a5a" stroke="#fff" strokeWidth="1" fontFamily="system-ui, sans-serif">
        99!
      </text>
    </svg>
  );
}
